<template>
  <div class="w-100 bg-light-page">
    <HotelTopNavbar />
    <block :height="83" />
    <span
      id="cart-top-section"
      class="position-absolute"
      style="top: 0 !important"></span>
    <div class="ga-container fluid d-block pb-5">
      <div class="row">
        <div class="col-xl-8 col-lg-7 col-md-12 order-lg-1 order-2">
          <div v-if="!$is_mobile_view" class="my-4">
            <HotelCheckoutStepper :steps="steps" :current-step="currentStep" />
          </div>
          <template v-if="viewType === 'FORM'">
            <!-- CONTACT DETAIL -->
            <div
              class="w-100 bg-white box-shadow-main rounded-6 border p-4 mb-5">
              <p class="mb-4 heading-6-1">Fill in data</p>
              <ContactDetail
                ref="contactDetail"
                :disabledForm="pushStatus.isLoad" />
              <div class="w-100 pt-4 mt-4 border-t-form-2-dashed">
                <label class="body-2 mb-1 d-block">Special request</label>
                <textarea
                  :disabled="pushStatus.isLoad"
                  @input="setConciergeTrxGeneralNotes(notes)"
                  class="p-3 body-2-1 w-100 border-form radius-6 w-100"
                  rows="2"
                  v-model="notes"></textarea>
              </div>
            </div>

            <!-- PAYMENT METHOD -->
            <span id="cart-payment"></span>
            <div
              class="w-100 bg-white box-shadow-main rounded-6 border p-4 mb-5">
              <p class="mb-4 heading-6-1">Select Payment Method</p>
              <PaymentMethod
                ref="paymentMethod"
                module="booking-engine"
                @selectPayment="selectPaymentMethod"
                :disabledForm="pushStatus.isLoad" />
            </div>

            <div v-if="pushStatus.error != ''" class="w-100 text-left mb-4">
              <ErrorMessage :message="pushStatus.error" />
            </div>

            <state-button
              variant="secondary"
              size="lg"
              :click="submitForm"
              :block="$is_mobile_view">
              Pay Now
            </state-button>
          </template>

          <div
            v-if="viewType === 'PAYMENT'"
            class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 mb-5">
            <XenditInputCC
              :tx_payment="pushResult.payment"
              module_page="BOOKING_ENGINE"
              submodule_page="BE_ADDITIONAL_SERVICE"
              @done="resetSavedData"
              @expired="goToSearchPage">
            </XenditInputCC>
          </div>
        </div>

        <div
          class="col-xl-4 col-lg-5 col-md-12 order-lg-2 order-1 mb-lg-0 mb-5">
          <div class="general-booking-summary">
            <div v-if="$is_mobile_view" class="mb-4">
              <HotelCheckoutStepper
                :steps="steps"
                :current-step="currentStep" />
            </div>
            <CartPreview
              :paymentSurcharge="paymentSurcharge"
              :disabledForm="pushStatus.isLoad" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import { post } from '@/services/index.js';

import ContactDetail from '../../../components/hotel/be/additionalService/ContactDetail.vue';
import CartPreview from '../../../components/hotel/be/additionalService/CartPreview.vue';
import PaymentMethod from '../../../components/general/payment/PaymentMethod.vue';
import XenditInputCC from '@/components/hotel/be/XenditInputCC';
import HotelTopNavbar from '../../../components/hotel/HotelTopNavbar.vue';
import HotelCheckoutStepper from '../../../components/hotel/be/HotelCheckoutStepper.vue';

export default {
  components: {
    HotelTopNavbar,
    ContactDetail,
    CartPreview,
    PaymentMethod,
    XenditInputCC,
    HotelCheckoutStepper,
  },
  data() {
    return {
      steps: [
        { order: 1, title: 'Your Selection' },
        { order: 2, title: 'Your Details' },
        { order: 3, title: 'Final Step' },
      ],
      viewType: 'FORM', // ["FORM", "PAYMENT"]
      currentStep: 2,
      windowWidth: window.innerWidth,
      notes: '',
      paymentMethod: {},
      pushStatus: {
        isLoad: false,
        error: '',
      },
      pushResult: {
        inquiry: {},
        payment: {},
      },
    };
  },
  computed: {
    ...mapGetters([
      'getMerchant',
      'getConciergeTrxGeneral',
      'getActivityTrxProducts',
      'getOutletTrxProducts',
      'getVoucherOrder',
      'getActivityTrxTotal',
      'getOutletTrxTotal',
      'getVoucherOrderTotal',
    ]),
    totalPrice() {
      return (
        Number(this.getActivityTrxTotal) +
        Number(this.getOutletTrxTotal) +
        Number(this.getVoucherOrderTotal)
      );
    },
    paymentSurcharge() {
      if (this.$isEmpty(this.paymentMethod)) return 0;
      const { surcharge_type, surcharge_value } = this.paymentMethod;
      return surcharge_type == 'PERCENT'
        ? (this.totalPrice / 100) * surcharge_value
        : surcharge_value;
    },
  },
  watch: {
    totalPrice() {
      if (this.totalPrice === 0) {
        this.$router.push(`/${this.getMerchant.code}/booking`);
      }
    },
  },
  mounted() {
    if (this.totalPrice === 0) {
      this.$router.push(`/${this.getMerchant.code}/booking`);
    } else {
      this.$smoothScroll('cart-top-section');
      this.getNoteDataFromVuex();
    }
  },
  methods: {
    ...mapMutations([
      'setConciergeTrxGeneralNotes',
      'resetAllDataConcierge',
      'resetAllDataMarketing',
    ]),
    goToPage(page) {
      this.$router.push({
        name: page,
        params: {
          merchant_code: this.getMerchant.code,
        },
      });
    },
    getNoteDataFromVuex() {
      this.notes = this.getConciergeTrxGeneral.notes;
    },
    selectPaymentMethod(paymentMethod) {
      this.paymentMethod = paymentMethod;
    },

    async validateForm() {
      try {
        const isContactValid = this.$refs.contactDetail.validateForm();
        if (!isContactValid) {
          this.$smoothScroll('cart-top-section');
          return false;
        }

        await this.$refs.paymentMethod.validateForm();
        return true;
      } catch (error) {
        if (error === 'PAYMENT') {
          this.$smoothScroll('cart-payment');
          return false;
        }
        throw error;
      }
    },

    formatProductListParams() {
      try {
        let productPerPos = [];

        const addProductPerPos = (
          merchant_pos_id,
          product,
          otherProductData = {}
        ) => {
          const { id, qty, notes } = product;

          const productPerPosIndex = productPerPos.findIndex(
            (pos) => pos.merchant_pos_id === merchant_pos_id
          );
          if (productPerPosIndex === -1) {
            productPerPos.push({
              merchant_pos_id,
              products: [{ id, qty, notes, ...otherProductData }],
            });
          } else {
            productPerPos[productPerPosIndex].products.push({
              id,
              qty,
              notes,
              ...otherProductData,
            });
          }
        };

        // SPA/ACTIVITY
        this.getActivityTrxProducts.forEach((product, index) => {
          const {
            qty,
            notes = '',
            therapist_gender,
            place_choice,
            service_date,
            service_time,
            original_data: {
              product_merchant_pos,
              product_ga_pos_id,
              use_schedule,
            },
          } = product;

          let otherProductData = {
            therapist_gender,
            place_choice,
            service_date: moment(service_date).format('YYYY-MM-DD'),
            schedule_id: use_schedule ? service_time.id : null,
          };

          otherProductData.service_date += use_schedule
            ? ' 00:00'
            : ` ${moment(service_time.schedule_start, 'HH:mm:ss').format(
                'HH:mm'
              )}`;

          addProductPerPos(
            product_merchant_pos[0].id,
            { id: product_ga_pos_id, qty, notes },
            otherProductData
          );
        });

        // OUTLET
        this.getOutletTrxProducts.forEach((product, index) => {
          const isProductVariant = product.variants.length > 0;
          if (isProductVariant) {
            const {
              product_data: { product_pos },
              variants,
            } = product;
            variants.forEach((variant) => {
              const {
                qty,
                notes,
                variant_data: { product_ga_pos_id },
              } = variant;
              addProductPerPos(product_pos[0].id, {
                id: product_ga_pos_id,
                qty,
                notes,
              });
            });
          } else {
            const {
              qty,
              notes,
              product_data: { product_merchant_pos, product_ga_pos_id },
            } = product;
            addProductPerPos(product_merchant_pos[0].id, {
              id: product_ga_pos_id,
              qty,
              notes,
            });
          }
        });

        // VOUCHER
        this.getVoucherOrder.cart.forEach((voucher) => {
          const { pos, product } = voucher;
          product.forEach((productItem) => {
            const {
              variant_list: variants,
              is_variant: isVariant,
              qty,
              notes,
              data,
            } = productItem;

            if (isVariant) {
              variants.forEach((variant) => {
                const {
                  qty: variantQty,
                  notes: variantNotes,
                  data: { product_ga_pos_id },
                } = variant;
                addProductPerPos(pos.id, {
                  id: product_ga_pos_id,
                  qty: variantQty,
                  notes: variantNotes,
                });
              });
            } else {
              addProductPerPos(pos.id, {
                id: data.product_ga_pos_id,
                qty,
                notes,
              });
            }
          });
        });

        return productPerPos;
      } catch (error) {
        throw error;
      }
    },
    getInquiryParams() {
      try {
        const unnecessaryParam = {
          room_id: '',
          region: '',
          promo_code: '',
          campaign_id: '',
          guest_journey_id: '',
        };

        return {
          merchant_id: this.getMerchant.id,
          customer_detail: this.getConciergeTrxGeneral.contactDetails,
          notes: this.notes,
          device: this.$getDeviceType(),
          payment_mode: 'PAY_IMMEDIATELY',
          tx_merchant_pos: this.formatProductListParams(),
          source: 'BOOKING_ENGINE',
          ...unnecessaryParam,
        };
      } catch (error) {
        throw error;
      }
    },
    async pushInquiry() {
      try {
        const apiParams = this.getInquiryParams();
        const apiResponse = await post(
          'CORE_HOTEL',
          'merchant-pos/multiple/tx-inquiry',
          apiParams
        );
        const { success, data, message } = apiResponse.data;
        if (!success) throw new Error(message);
        this.pushResult.inquiry = data;
      } catch (error) {
        throw error;
      }
    },

    getPaymentParams() {
      try {
        const { first_name, last_name, email, phone_number } =
          this.getConciergeTrxGeneral.contactDetails;

        const { id: inquiryId, total_payment } = this.pushResult.inquiry;
        let totalAmount = Number(total_payment) + Number(this.paymentSurcharge);

        const {
          id: paymentMethodId,
          payment_method,
          bank_name,
          payment_channel,
        } = this.paymentMethod;

        return {
          merchant_id: this.getMerchant.id,
          tx_order_invoice_id: inquiryId,
          amount: Number(totalAmount.toFixed(2)),
          customer_detail: {
            name: `${first_name}${
              this.$isEmpty(last_name) ? '' : ' ' + last_name
            }`,
            email,
            phone_number,
          },
          payment_details: {
            id: paymentMethodId,
            payment_method,
            bank_name,
            payment_channel,
          },
        };
      } catch (error) {
        throw error;
      }
    },
    async pushPayment() {
      try {
        const apiParams = this.getPaymentParams();
        const apiResponse = await post(
          'CORE_HOTEL',
          'merchant-pos/tx-payment',
          apiParams
        );
        const { success, payment, message, tx_order_id } = apiResponse.data;
        if (!success) throw new Error(message);
        this.pushResult.payment = payment;

        const { bank_name, payment_method } = this.paymentMethod;
        const isPaymentXenditCreditCard =
          bank_name === 'XENDIT' && payment_method === 'CREDIT_CARD';

        if (isPaymentXenditCreditCard) {
          this.pushResult.payment.tx_order_id_2 = tx_order_id;
          this.viewType = 'PAYMENT';
        } else {
          this.$proceedPayment(
            'BE_ADDITIONAL_SERVICE',
            this.pushResult.inquiry,
            apiResponse.data,
            this.paymentMethod
          );
        }
      } catch (error) {
        throw error;
      }
    },

    async submitForm() {
      try {
        const isAllDataValid = await this.validateForm();
        if (!isAllDataValid) return;

        this.pushStatus = {
          isLoad: true,
          error: '',
        };

        await this.pushInquiry();
        await this.pushPayment();
      } catch (error) {
        this.pushStatus.error = error;
      } finally {
        this.pushStatus.isLoad = false;
        Promise.resolve();
      }
    },

    resetSavedData() {
      this.resetAllDataConcierge();
      this.resetAllDataMarketing();
      this.$router.push({
        name: 'BePaymentResult',
        params: {
          tx_order_id: this.pushResult.inquiry.id,
        },
        query: {
          module: 'additional-service',
        },
      });
    },
    goToSearchPage() {
      this.$router.push(`/${this.getMerchant.code}/booking`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/hotel/be/BeCartAdditional.vue